import React from 'react'

export const MAX_COMBINATIONS = 2

/*
* Let's store some variables to use it globaly
*/
export function getVariables() {
    //common variables
    const options = {
        'site': 'us.mattress.zone',
        'home': 'Home',
        'mattress': 'mattress',
        'mattresses': 'mattresses',
        'mattress_vs': '-mattress-vs-',
        'compare': 'compare',
        'comparer': 'comparer',
        'comparison': 'comparison',
        'review': 'review',
        'reviews': 'reviews',
        'contact': 'contact',
        'privacy': 'privacy',
        'message_limit': 'You have selected the maximum products allowed to compare. Please remove a mattress to add another (three allowed).',
        'last_updated_on': 'Last updated on',
        'add_another_mattress': 'Add another mattress',
        'popular_comparisons': 'Popular comparisons',
        'enter_mattress_name': 'Enter mattress name',
        'add_title': 'Select this mattress to compare',
        'list_mattress_text': 'Select from these frequently compared mattresses',
        'view_article': 'View Article',
        'remove': 'Remove item',
        'view_all_reviews': 'View All Reviews',
        'recent_reviews': 'Recent Reviews',
        'shop_now': 'Shop now',
        'read_more': 'Read more',
        'price_range': 'Price Range',
        'firmness': 'Firmness',
        'mattress_type': 'Mattress Type',

        'mattress-type': 'mattress-type',
        'details': 'Details',
        'brand': 'brand',
        'certifications': 'certifications',
        'certification': 'certification',
        'view_mattresses': 'View Mattresses',

        'about_us': 'About us',
        'cookie_message': 'This website uses cookies to ensure you get the best experience on our website.',
        'find_out_more': 'Learn more.',
        'guides': 'Guides',
        'company': 'Company',
        'region': 'Region',
        'alt_promotion': 'This is a link to {brand} website',
    }
    return options
}

/**
 * Return jsx components from a promotion array processed and ready to be inserted into a fragment
 * @param  {Array} promotions array of promotions from DATOcms
 * @return {JSX}      JSX frament
 */
export function getPromotions(promotions, brand_name) {
    let affiliate_link = null
    let shortened_affiliate_link = null
    const variables = getVariables()

    let start_date = null
    //let end_date = null   //TODO
    let show_promotion = false
    let today_date = new Date()

    let mattres_prom = []
    if (promotions && promotions.length) {
        //iterate the promotions in case there's more than one
        for (let i = 0; i < promotions.length; i++) {
            if (promotions[i].startDate) {
                start_date = new Date(promotions[0].startDate)
            }
            if (promotions[i].endDate) {
                //end_date = new Date(promotions[i].endDate)
            }

            if (promotions[i].affiliateLinkPromotion.affiliateLink) {
                affiliate_link = promotions[i].affiliateLinkPromotion.affiliateLink
            }
            if (promotions[i].affiliateLinkPromotion.shortenedAffiliateLink) {
                shortened_affiliate_link = promotions[i].affiliateLinkPromotion.shortenedAffiliateLink
            }

            if (start_date !== null) {
                //date setup so check ranges
                if (start_date.getTime() < today_date.getTime()) {
                    show_promotion = true
                }
            } else {
                show_promotion = true
            }

            //Added a default text on Chris request
            let alt_title = variables.alt_promotion
            if (promotions[i].altTitle) {
                alt_title = promotions[i].altTitle
            }
            alt_title = alt_title.replace('{brand}', brand_name)

            if (show_promotion) {
                mattres_prom.push(<div key={`item-promotions-key-${i}`}>
                    <div className="text-lg text-center text-zone-2 mb-2" dangerouslySetInnerHTML={{ __html: promotions[i].description }} />
                    {/*eslint-disable-next-line*/}
                    <a
                        className="btn-coupon font-grotesk text-white bg-zone-6 p-4 mb-4 block uppercase text-center font-semibold rounded-3xl duration-300 hover:bg-zone-14"
                        href={shortened_affiliate_link ? shortened_affiliate_link : affiliate_link}
                        target="_blank"
                        rel="nofollow noopener sponsored"
                        title={alt_title}
                    >
                        {promotions[i].affiliateLinkCta}
                    </a>
                </div>)
            }
        }
    }
    return mattres_prom
}

/**
 * Return a link to a valid promotion ready to be inserted into an anchor
 * @param  {Array} promotions array of promotions from DATOcms
 * @return {String}      Promotion link
 */
export function getPromotionLink(mattress) {
    let affiliateLink = null
    //Iterating the mattress lets check for the brand promotion first
    if (mattress.brand.promotions && mattress.brand.promotions.length) {
        affiliateLink = iteratePromotions(mattress.brand.promotions)
    } else {
        //no brand promotion, try product promotion
        if (mattress.promotions.length > 0) {
            affiliateLink = iteratePromotions(mattress.promotions)
        }
    }
    return affiliateLink
}

export function iteratePromotions(promotions) {
    let result_link = null
    let affiliate_link = null
    let shortened_affiliate_link = null

    let start_date = null
    //let end_date = null
    let show_promotion = false
    let today_date = new Date()

    if (promotions && promotions.length) {
        //iterate the promotions in case there's more than one
        for (let i = 0; i < promotions.length; i++) {
            if (promotions[i].startDate) {
                start_date = new Date(promotions[0].startDate)
            }
            if (promotions[i].endDate) {
                //end_date = new Date(promotions[i].endDate)
            }

            if (promotions[i].affiliateLinkPromotion.affiliateLink) {
                affiliate_link = promotions[i].affiliateLinkPromotion.affiliateLink
            }
            if (promotions[i].affiliateLinkPromotion.shortenedAffiliateLink) {
                shortened_affiliate_link = promotions[i].affiliateLinkPromotion.shortenedAffiliateLink
            }

            if (start_date !== null) {
                //date setup so check ranges
                if (start_date.getTime() < today_date.getTime()) {
                    show_promotion = true
                }
            } else {
                show_promotion = true
            }

            if (show_promotion) {
                if (shortened_affiliate_link) {
                    result_link = shortened_affiliate_link
                } else {
                    if (affiliate_link) {
                        result_link = affiliate_link
                    }
                }
            }
        }
    }
    return result_link
}

export function getNewestDate(dates) {
    let result = null

    if (Array.isArray(dates) && dates.length) {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]

        let localUpdate = new Date(Math.max.apply(null, dates.map(function (e) {
            return new Date(e)
        })))

        let newestUpdate = new Date(localUpdate.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }))

        let month_id = newestUpdate.getMonth()
        let month = months[month_id]
        let day = newestUpdate.getDate()
        let year = newestUpdate.getFullYear()

        result = { 'day': day, 'month': month, 'year': year }
    }

    return result
}


export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

export function getexcerpt(content, wordlimit) {
    var filter = content.replace(/\s+/g, ' ')
    var wordsarr = filter.split(' ')

    if (wordsarr.length < wordlimit) {
        return content
    }

    else {
        var result = ""

        for (var i = 0; i < wordlimit; i++) {
            result = result + " " + wordsarr[i] + " "
        }

        return result
    }
}

//add or remove items from array based on the value or custom object key
export function addOrRemove(array, item, checked) {
    if (checked) { //add to the array
        array.push(item)
        return array
    } else { //remove from the array
        const result = array.filter((c) => {
            if (typeof item === 'object' && item !== null) {
                //special logic to handle price object type data
                return c.name !== item.name
            } else {
                return c !== item
            }
        })
        return result
    }
}

// Filters an array of objects using custom predicates.
export function filterArray(array, filters) {
    const filterKeys = Object.keys(filters)

    return array.filter(item => {
        // validates all filter criteria

        return filterKeys.every(key => {
            if (!filters[key].length) {
                return true
            }

            if (key === 'size') {
                return item.buttons.some(keyEle => {
                    return filters[key].includes(keyEle.size.sizeName)
                })
            } else if (key === 'price') {

                return item.buttons.some(keyEle => {
                    //keyEle.price
                    let results = filters[key].filter(itemFilter => {

                        if (itemFilter.end >= keyEle.price && itemFilter.start <= keyEle.price) {
                            //let's also check for the size if present
                            if (filters['size'].length > 0) {
                                if (filters['size'].includes(keyEle.size.sizeName)) {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                return true
                            }
                        }
                        return false
                    })

                    if (results.length > 0) {
                        return true
                    }
                    return false
                })

            } else if (key === 'search') {
                return item.name.toLowerCase().includes(filters[key])
            } else {
                return filters[key].includes(item[key].slug)
            }
        })
    })
}

//custom function to process prices by mattress discount percentage, fixed discount, or brand discount by percentage fixed, etc
export function calculateFinalPrice(node) {
    let discountFlat = null   //in this case it's equal to 0
    let discountPercentage = null //in this case it's equal to 0

    if (node.discountFlat !== null && node.discountFlat !== undefined) {
        discountFlat = node.discountFlat
    } else {
        if (node.brand.discountFlat !== null && node.brand.discountFlat !== undefined) {
            discountFlat = node.brand.discountFlat
        }
    }

    if (node.discountPercentage !== null && node.discountPercentage !== undefined) {
        discountPercentage = node.discountPercentage
    } else {
        if (node.brand.discountPercentage !== null && node.brand.discountPercentage !== undefined) {
            discountPercentage = node.brand.discountPercentage
        }
    }

    //next, replace price with sale if available, also calculate the discounts
    //last replace all buttons vor the node with the final value

    const buttons = node.buttons.map(button => {
        let price = button.price
        let salePrice = button.salePrice

        if (button.salePrice !== null && button.salePrice !== undefined) {
            price = salePrice
        } else {
            //no sale price so calculate the price based on the discount logic
            if (discountFlat !== null) {
                price = price - discountFlat
            } else {
                if (discountPercentage !== null) {
                    price = price - ((discountPercentage * price) / 100)
                }
            }
        }

        return {
            ...button,
            price: price.toFixed(2)
        }
    })

    return {
        ...node,
        buttons: buttons
    }
}

export function generatePath(items = [], locale = 'en', countryCode = null, translateMattress = 'mattress') {
    let path
    if (items.length > 1) {
        path = locale === 'en' || locale === 'de' ? items.join('-' + translateMattress + '-vs-') : items.join('-vs-' + translateMattress + '-')
        path = locale === 'en' || locale === 'de' ? path + '-' + translateMattress : translateMattress + '-' + path
    } else {
        path = locale === 'en' || locale === 'de' ? items + '-' + translateMattress : translateMattress + '-' + items
    }

    let fullPath = '/' + path
    if (countryCode) {
        fullPath = '/' + countryCode + '/' + path
    }
    return fullPath
}